module.exports = __webpack_public_path__ + "static/media/logo-pinterest.870c40e9.svg";